import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, QueryList, ViewChildren, Inject } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DropdownHttpService } from '@core/services/dropdown-http.service';
import { EventEmitterService } from '@core/services/event-emitter.service';
import { of, Subscription } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { AllLeadsDataService } from '../../services/all-leads-data.service';
import { AuthHttpService } from '@core/services/auth-http.service';
import { TranslateService } from '@ngx-translate/core';
import { TransactionHttpService } from '@core/services/transaction-http.service';
import * as moment from 'moment-timezone';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './reassign-lead.component.html',
  styleUrls: ['./reassign-lead.component.scss']
})
export class ReassignLeadsDialogComponent implements OnInit, OnDestroy {

  @ViewChildren('focusfield') focusfield: QueryList<ElementRef>;
  form: FormGroup;
  dropdown= {
    merchantSites: [],
    lead_statuses: this.dropdownHttpService.lead_statuses,
  };
  // currentStep = 1;

  statusList = {
    0: 'Closed',
    1: 'Active',
    3: 'Partially Closed'
  };

  telemarketerDropdownList = [];

  fromTelemarketerDropdownSettings = {};
  fromTelemarketerSelectedItems = [];
  fromTelemarketerDropdownList = [];

  toTelemarketerDropdownSettings = {};
  toTelemarketerSelectedItems = [];
  toTelemarketerDropdownList = [];
  allToTelemarketerDropdownList = [];

  leadsDropdownSettings = {};
  leadsSelectedItems = [];
  leadsDropdownList = [];
  allLeadsDropdownList = [];

  statuesDropdownSettings = {};
  statuesSelectedItems = [];
  statuesDropdownList = [
    { id: 0, name: 'Closed' },
    { id: 1, name: 'Active' },
    { id: 2, name: 'Expired' },
    { id: 3, name: 'Partially Closed' },
    { id: 4, name: 'Failed' },
    { id: 6, name: 'Pending Justification' },
    { id: 7, name: 'Rejected Justification' },
    { id: 9, name: 'Following Up' },
  ];

  ranges: any;
  dateTimePickerLocale = this.transactionHttpService.dateTimePickerLocale;
  invalidDateRange = false;
  timezone = JSON.parse(localStorage.getItem('user_data')).timezone;

  data1$ = this.allLeadsDataService.data1$;
  messages1$ = this.allLeadsDataService.messages1$;
  invalidLeadList =[];

  refreshStatus: boolean;
  buttonLoading: boolean;

  private subscription = new Subscription();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { leadID: any},
    public dialogRef: MatDialogRef<ReassignLeadsDialogComponent>,
    private allLeadsDataService: AllLeadsDataService,
    private dropdownService: DropdownHttpService,
    private cdr: ChangeDetectorRef,
    private eventEmitterService: EventEmitterService,
    private authHttpService: AuthHttpService,
    private translateService: TranslateService,
    private transactionHttpService: TransactionHttpService,
    private dropdownHttpService: DropdownHttpService,
  ) { }

  ngOnInit() {
    this.formInit();

    // AIO-84232: include Account Managers so leads they still hold can be reassigned
    this.allLeadsDataService.getTelemarketerList(`?include_account_manager=1`).subscribe(res => {
      this.telemarketerDropdownList = res;
      this.fromTelemarketerDropdownList = this.telemarketerDropdownList.filter((value, index, self) => 
        self.findIndex(v => v.id === value.id) === index
      );

      this.fromTelemarketerDropdownList.sort((a, b) => a.username.localeCompare(b.username));
      

      if (this.data.leadID !== undefined) {
        this.fromTelemarketerSelectedItems = this.telemarketerDropdownList.filter(x => x.id == this.data.leadID.lead_telemarketer_id);
        this.statuesSelectedItems = this.statuesDropdownList.filter(x => x.id == this.data.leadID.status);
        this.form.patchValue({
          defaultDate: {
            startDate: moment(this.data.leadID.lead_assigned_date).format('YYYY-MM-DD HH:mm:ss'),
            endDate: moment(this.data.leadID.lead_assigned_date).format('YYYY-MM-DD HH:mm:ss'),
          },
          start_date: this.data.leadID.lead_assigned_date,
          end_date: this.data.leadID.lead_assigned_date,
          lead_status: [this.data.leadID.status],
        });
        this.cdr.detectChanges();
        let data = [];

        data['telemarketer_id'] = this.data.leadID.lead_telemarketer_id;
        data['from_telemarketer_id'] = this.data.leadID.lead_telemarketer_id;
        data['start_date'] = moment(this.data.leadID.lead_assigned_date).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        data['end_date'] = moment(this.data.leadID.lead_assigned_date).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
        data['lead_status'] = this.data.leadID.status;
        data['reassign'] = 1;

        let params = Object.keys(data)
            .map((key) => key + "=" + data[key])
            .join("&");

        this.allLeadsDataService.getTelemarketerUnusedLeads(params).subscribe(res => {
          this.allToTelemarketerDropdownList = res['available_telemarketers'].sort((a, b) => a.username - b.username);
          this.toTelemarketerDropdownList = Object.assign([], this.allToTelemarketerDropdownList);
          this.toTelemarketerDropdownList = this.toTelemarketerDropdownList.filter(x => x['settings_currency_ids'].includes(this.data.leadID.settings_currency_id));

          this.leadsDropdownList = res['available_leads'];
          this.leadsDropdownList.map(function (elm) {
            if (elm.username != null) {
              elm['labelKey'] = elm.username + ' (' + elm.id + ')';
            } else {
              elm['labelKey'] = elm.mobile + ' (' + elm.id + ')';
            }
          });

          this.leadsSelectedItems = this.leadsDropdownList.filter(x => x.id == this.data.leadID.lead_id);
          this.form.patchValue({
            telemarketer_id: this.data.leadID.lead_telemarketer_id,
            from_telemarketer_id: this.data.leadID.lead_telemarketer_id,
            to_telemarketer_id: null,
            lead_ids: [this.data.leadID.lead_id],
          })

          this.cdr.detectChanges();
        });
      }
      else {
        this.form.patchValue({ 
          telemarketer_id: null,
          from_telemarketer_id: null,
          to_telemarketer_id: null,
          lead_ids: null,
        });
      }
    });

    this.fromTelemarketerDropdownSettings = {
      autoPosition: false,
      singleSelection: true,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'username',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false
    };

    this.toTelemarketerDropdownSettings = {
      autoPosition: false,
      singleSelection: true,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'username',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false
    };

    this.statuesDropdownSettings = {
      autoPosition: false,
      singleSelection: false,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'name',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false,
    };

    this.leadsDropdownSettings = {
      autoPosition: false,
      singleSelection: false,
      text: this.translateService.instant('Please Select'),
      maxHeight: 200,
      enableFilterSelectAll: false,
      enableSearchFilter: true,
      classes: 'dropdown',
      primaryKey: 'id',
      labelKey: 'labelKey',
      lazyLoading: false,
      noDataLabel: '',
      showCheckbox: false
    };

  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    this.onRefresh();
  }

  onCloseDialog() {
    this.dialogRef.close();
  }
  
  onSubmit(skip = false) {
    this.buttonLoading = true;

    const data = {
      ...this.form.value,
      lead_status: this.form.value.lead_status.join(','),
      reassign: 1,
      skip: skip
    };
    
    if (skip) {
      data['lead_ids'] = data['lead_ids'].filter(x => !this.invalidLeadList.includes(x.toString()));
    }

    this.subscription = this.allLeadsDataService.reassignLead(data).pipe(
      tap((res) => {
        const regex = /\((\d+)\)/;

        if (res['data']?.invalid_lead_list.length > 0) {
          res['data'].invalid_lead_list.forEach(lead => {
            const match = lead.match(regex);

            if (match) {
              this.invalidLeadList.push(match[1]);
            }
          });
        }
        else {
          this.dialogRef.close();
        }
        
        this.form.setErrors(null);
        //this.dialogRef.close(true);
        this.buttonLoading = false;
        this.refreshStatus = true;
      }),
      catchError((error) => {
        this.form.setErrors(null);
        this.buttonLoading = false;
        this.refreshStatus = false;
        throw error;
      })
    ).subscribe();
  }

  onRefresh() {
    if (this.refreshStatus === true) {
      this.dialogRef.close(true);
    }
  }

  private formInit() {
    this.form = new FormGroup({
      telemarketer_id: new FormControl(null, [Validators.required]),
      from_telemarketer_id: new FormControl(null, [Validators.required]),
      to_telemarketer_id: new FormControl(null, [Validators.required]),
      lead_ids: new FormControl(null, [Validators.required]),
      status: new FormControl(1, [Validators.required]),
      lead_status: new FormControl([]),
      start_date: new FormControl(null),
      end_date: new FormControl(null),
      defaultDate: new FormControl(null),
    });

    this.cdr.detectChanges();
  }

  onSelectFromTelemarketer(event: any) {
    this.resetLead();
    if (event.length > 0) {
      this.fromTelemarketerSelectedItems = event;
      this.form.patchValue({
        telemarketer_id: this.fromTelemarketerSelectedItems[0].id,
        from_telemarketer_id: this.fromTelemarketerSelectedItems[0].id
      })
      
      this.getReassignLead();
    }
    else {
      this.form.patchValue({ 
        telemarketer_id: null,
        from_telemarketer_id: null,
      });

      this.fromTelemarketerSelectedItems = [];
    }
    
    this.cdr.detectChanges();
  }

  onSelectToTelemarketer(event: any) {
    if (this.data.leadID === undefined) {
       this.form.patchValue({ 
        lead_ids: null,
      });
      this.leadsDropdownList = [];
      this.leadsSelectedItems = [];
      this.cdr.detectChanges();

      if (event.length > 0) {
        this.toTelemarketerSelectedItems = event;
        this.leadsDropdownList = Object.assign([], this.allLeadsDropdownList);
        this.leadsDropdownList = this.leadsDropdownList.filter(x => event[0]['settings_currency_ids'].includes(x.settings_currency_id));
        this.leadsDropdownList.map(function (elm) {
          if (elm.username != null) {
            elm['labelKey'] = elm.username + ' (' + elm.id + ') - ' + elm.lead_status_name;
          } else {
            elm['labelKey'] = elm.mobile + ' (' + elm.id + ') - ' + elm.lead_status_name;
          }
        });
      }
      else {
        this.form.patchValue({ 
          to_telemarketer_id: null,
        });
        this.toTelemarketerSelectedItems = [];
      }
    }
    else {
      this.toTelemarketerSelectedItems = event;
    }
  }

  onSelectLeadStatus(event: any) {
    this.resetLead();
    if (event.length > 0) {
      setTimeout(() => {
        this.getReassignLead();
      }, 500);
    }
    else {
      this.form.patchValue({ 
        status: [],
      });

      this.statuesSelectedItems = [];
    }
    this.cdr.detectChanges();
  }

  resetLead() {
    this.form.patchValue({ 
      to_telemarketer_id: null,
      lead_ids: null,
    });
    this.toTelemarketerSelectedItems = [];
    this.toTelemarketerDropdownList = [];
    this.leadsSelectedItems = [];
    this.leadsDropdownList = [];
  }

  onConfirmation() {
    let textMessage = `<br><br>Current Status: <span class='kt-badge-font-${this.data.leadID.status}'><b>${this.data.leadID.status_name}</b></span><br>New Status: <span class='kt-badge-font-${this.form.value.status}'><b>${this.statusList[this.form.value.status]}</b></span>`
    let leadMessage = this.data.leadID.username !== null ? this.data.leadID.username : this.data.leadID.mobile + ' (' + this.data.leadID.lead_id + ')';
    Swal.fire({
      icon: "info",
      title: `<div>Reassign Lead Confirmation</div>`,
      html: `Are you sure you want to reassign <b>${leadMessage}</b> to <b>${this.toTelemarketerSelectedItems[0].username}</b>?` + textMessage,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'Cancel',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
    }).then((result) => {
      if (result.isConfirmed) {
        this.onSubmit();
      }
    });
  }

  onDateRange(event: any) {
    this.resetLead();
    this.invalidDateRange = false;
    this.form.patchValue({
      start_date: event.startDate !== null && event.startDate !== undefined ? event.startDate : null,
      end_date: event.endDate !== null && event.endDate !== undefined ? event.endDate : null
    });

    if (event) {
      if (event.startDate && event.endDate && event.endDate.diff(event.startDate, 'days') > 31) {
        this.invalidDateRange = true;
      }
      else {
        this.getReassignLead();
        this.invalidDateRange = false;
      }

      this.cdr.detectChanges();
    }
  }

  onClearDate() {
    if (this.form.value.start_date !== null) {
      this.form.patchValue({ defaultDate: null });
      this.invalidDateRange = false;
    }
  }

  updateDateRange() {
    this.ranges = this.transactionHttpService.updateDateRange();
  }

  getReassignLead() {
    if (this.form.value.from_telemarketer_id && this.form.value.lead_status.length > 0 && this.form.value.start_date && this.form.value.end_date && !this.invalidDateRange) {
      of(this.form.value)
      .pipe(
        map(this.filterFormFields),
        tap((data) => {
          data['start_date'] = moment(data['start_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          data['end_date'] = moment(data['end_date']).tz(this.timezone, true).utc().format('YYYY-MM-DD HH:mm:ss');
          data['reassign'] = 1;

          let params = Object.keys(data)
            .map((key) => key + "=" + data[key])
            .join("&");

          this.subscription.unsubscribe();
          this.subscription = this.allLeadsDataService.getTelemarketerUnusedLeads(params).subscribe(res => {
            this.allToTelemarketerDropdownList = res['available_telemarketers'].sort((a, b) => a.username - b.username);
            this.toTelemarketerDropdownList = Object.assign([], this.allToTelemarketerDropdownList);
            this.allLeadsDropdownList = res['available_leads'];
          });
        },
        catchError((error) => {
          this.buttonLoading = false;
          this.form.setErrors(null);
          throw error;
        })
      )).subscribe();
    }
  }

  private filterFormFields(formData: any) {
    const fields = {};
    Object.keys(formData).forEach(key => {
      if (formData[key] !== '' && formData[key] !== null && formData[key] !== undefined && formData[key] !== false && key !== 'defaultDate' && key !== 'contactType') {
        fields[key] = formData[key];
      }
    });
    return fields;
  }
}
